import * as React from "react";
import { SettingsContext } from "./AppStateProvider";
import { useTranslation } from "./i18n";
var TitleHandler = function (props) {
    var settings = React.useContext(SettingsContext);
    var t = useTranslation().t;
    React.useEffect(function () {
        var title = t("app.documentTitle");
        if (props.playerName !== undefined &&
            props.playerName !== null &&
            settings.showPlayerName) {
            document.title = "".concat(props.playerName, " | ").concat(title);
        }
        else {
            document.title = title;
        }
    }, [props.playerName, settings.showPlayerName, t]);
    return React.createElement(React.Fragment, null);
};
export default TitleHandler;
